/**
 *
 * @param key The key pressed
 * @param currentIndex The current index of the element
 * @param elementsPerRow The number of elements per row
 * @param totalElements The total number of elements
 * @returns the new index of the element to be focused
 */
export function navigateIndexIn2D(key: KeyboardEvent['key'], currentIndex: number, elementsPerRow: number, totalElements: number): number {
	const maxIndex = totalElements - 1;
	const deltas: Record<string, number> = {
		ArrowUp: -elementsPerRow,
		ArrowDown: elementsPerRow,
		ArrowLeft: -1,
		ArrowRight: 1,
	};

	const delta = deltas[key] ?? 0;
	return Math.min(Math.max(currentIndex + delta, 0), maxIndex);
}
